import React from "react";
import { FlatpickerHour, MessageError } from "../../atoms";
import { FlatpickerHourProps } from "../../atoms/FlatpickerHour";

import { Wrapper } from "./styles";

interface FlatpickerHourGroupProps extends FlatpickerHourProps {
  label?: string;
  messageError?: string;
}

export function FlatpickerHourGroup({
  label = "",
  className,
  messageError,
  ...props
}: FlatpickerHourGroupProps) {
  return (
    <>
      <Wrapper className={className}>
        {label ? <label htmlFor={props.id}>{label}</label> : ""}
        <FlatpickerHour {...props} />
      </Wrapper>
      <MessageError>{messageError}</MessageError>
    </>
  );
}
